import React from 'react'

interface Props {
    varient?: string
    small?: boolean,
    large?: boolean
}

const InlineSpinner = ({ varient, small , large }: Props) => {
    const largeStyle  = large ?  {width:"7rem", height:"7rem"} : undefined
    return (
        <div className={`spinner-border ${small && 'spinner-border-sm'} ${varient && `text-${varient}`}`} role="status"
        style={largeStyle}
        >
            <span className="visually-hidden">Loading...</span>
        </div>
    )
}

export default InlineSpinner